<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/feyCk2/tc-custom/9781466889118.jpg?1735616569139" alt="This image is the cover for the book James Tiptree, Jr."/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">James Tiptree, Jr.
      </h1>
      <p class="bookDescription body article font2">
        <b>“Phillips’s superb depiction [of] the woman behind the persona of science-fiction writer James Tiptree is an extraordinary achievement.” —<i>Kirkus Reviews</i>, starred review</b><br/><br/><b>A <i>New York Times Book Review </i>Notable Book of the Year</b><br/><br/><b>A <i>Washington Post Book World</i> Best Book of the Year</b><br/><br/><b>One of <i>Entertainment Weekly</i>’s 10 Best Nonfiction Books of the Year</b><br/><br/>Alice Bradley Sheldon was born in Chicago in 1915. As a child, she crossed Africa with her explorer parents. Later she became a painter, a CIA agent, a psychologist, and at age fifty-one made yet another career change.<br/><br/>James Tiptree, Jr., appeared on the science fiction scene in 1967. His stories were fast-paced and hard-boiled, his letters frank and sensitive. For nearly ten years he carried on intimate correspondences with fellow writers Philip K. Dick, Harlan Ellison, and Ursula K. Le Guin. But no one knew who he really was. Then, assumptions about writing and gender were demolished when “he” was revealed to be Alice B. Sheldon.<br/><br/>Based on extensive research and full access to Sheldon’s papers, <i>James Tiptree, Jr.</i>, is the suspenseful, engrossing, and tragic biography of a profoundly original writer and woman far ahead of her time.<br/><br/><b>“An incredible life, done elegant justice. Tiptree-Sheldon is one of the century’s astonishing figures.” —Jonathan Lethem, bestselling author of <i>The Fortress of Solitude</i></b><br/><br/><b>“Fascinating . . . May make you rethink your ideas about what it means to be male or female—or, for that matter, human.” —Francine Prose, <i>O, The Oprah Magazine</i></b><br/><br/><b>“The meticulous, emotionally intelligent biography of an extraordinary writer.” —William Gibson</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julie Phillips
      </h2>
      
      <p class="authorDescription body article">JULIE PHILLIPS is a journalist who has written on books, film, feminism, and cultural politics for <I>Newsday, Interview, Mademoiselle, </I>and for <I>Ms. </I>and <I>The Village Voice</I>. <I>James Tiptree, Jr.</I> is her first book. She lives in Amsterdam, Holland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?893505a2